import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/tailwind-styles.css';
import './styles/bootstrap-style-overrides.css';
import './styles/global-styles.css';
import './styles/utility-styles.css';
import './styles/theme.css';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { App } from './pages/app/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { App as CapacitorApp } from '@capacitor/app';
import { ThemeProvider } from './components/theme/ThemeProvider';

CapacitorApp?.addListener("backButton", () => {
    window.history.back();
});

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
    //<React.StrictMode>
    <ThemeProvider>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </ThemeProvider>
    //</React.StrictMode>
);

if (process.env.REACT_APP_INSTALL_SERVICE_WORKER === 'true') {
    serviceWorkerRegistration.register();
}